module.exports = __webpack_public_path__ + "media/images/responsive/articles/icon_header_search-6952849625924d300000be068ca625c7.svg";